module.exports = __webpack_public_path__ + "media/images/internship_banner-e43258c4b0fd1c12b407ffed1b6f1da2.jpg";